// src/utils/updateScore.js
import apiClient from '../services/apiClient'
import { buildApiUrl, getGrpApi, getGrpLocal } from './getConfiguration'

export default async function updateScore(add, grp_ID, fetchRecommendationsData) {
  try {
    const ls = typeof window !== 'undefined' ? window.localStorage : null
    if (!ls) throw new Error('localStorage is not available')

    const account_ID = ls.getItem('account_ID')
    if (!account_ID) throw new Error('Missing account_ID in localStorage')

    const accountscore = (Number(ls.getItem('accountscore')) || 0) + add
    ls.setItem('accountscore', String(accountscore))
    await apiClient.get(
      buildApiUrl('accountsScoreUpdate', {
        account_ID,
        score: String(accountscore),
      }),
    )

    const numericGroupId = Number(grp_ID)
    const grpKey = getGrpLocal(numericGroupId)
    const accountscoregrp = (Number(ls.getItem(grpKey)) || 0) + add
    ls.setItem(grpKey, String(accountscoregrp))
    await apiClient.get(
      getGrpApi(numericGroupId, {
        account_ID,
        score: String(accountscoregrp),
      }),
    )

    const month = new Date().getMonth() + 1
    const monthScoreKey = `score${month}`
    const accountmonthscore = (Number(ls.getItem(monthScoreKey)) || 0) + add
    ls.setItem(monthScoreKey, String(accountmonthscore))
    await apiClient.get(
      buildApiUrl('accountsScoreMonthUpdate', {
        account_ID,
        score: String(accountmonthscore),
        month: monthScoreKey,
      }),
    )

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('app:score-updated', {
          detail: {
            total: accountscore,
            group: accountscoregrp,
            monthKey: monthScoreKey,
            monthTotal: accountmonthscore,
          },
        }),
      )
    }

    if (fetchRecommendationsData) await fetchRecommendationsData()
  } catch (error) {
    console.error('updateScore failed:', error)
    throw error
  }
}
